module.exports = __webpack_public_path__ + "media/images/content/pic_direction_n-5df272dba6e215f27d6d0d7ba89f7aca.svg";